import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './components/layout/layout.component';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';

import { WorkflowGuard } from './components/routeGuard/workflow-guard.service';

import { RegexService } from '@shared/services/regex.service';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
export const routes: Routes = [
  {
    path: '',
    resolve: [RegexService],
    children: [
      {
        path: '',
        component: LayoutComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile-info',
          },
          {
            path: 'profile-info',
            component: ProfileInfoComponent,
            title: 'Profile Information',
          },
          {
            path: 'account-info',
            component: AccountInfoComponent,
            canActivate: [WorkflowGuard],
            title: 'Account Info',
          },
          {
            path: 'confirmation',
            component: ConfirmationComponent,
            canActivate: [WorkflowGuard],
            title: 'Confirmation',
          },
        ],
      },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    title: 'Not Found',
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RegistrationRoutingModule {}
